import styled from 'styled-components';

import EditorHeader from './EditorHeader/EditorHeader';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
`;

const Main = styled.div`
  display: flex;
  flex: 1;
  overflow: auto;
`;

interface EditorLayoutProps {
  children?: React.ReactNode;
}

const EditorLayout = ({ children }: EditorLayoutProps) => {
  return (
    <Container>
      <EditorHeader />
      <Main>{children}</Main>
    </Container>
  );
};

export default EditorLayout;
